import { apiGet, apiPost } from './client.js';

export interface ConversationListItem {
  id: string;
  tenantId: string;
  storeId: string;
  customerId: string | null;
  ticketId: string | null;
  channel: string;
  customerPhone: string | null;
  customerEmail: string | null;
  status: string;
  subject: string | null;
  lastMessageAt: string | null;
  lastMessagePreview: string | null;
  unreadCount: number;
  assignedTo: string | null;
  conversationType: string | null;
  customerName?: string | null;
  ticketNumber?: string | null;
  assigneeName?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface InboxMessage {
  id: string;
  conversationId: string;
  ticketId: string | null;
  direction: string;
  channel: string;
  fromAddress: string;
  toAddress: string;
  body: string;
  status: string;
  isAutomated: boolean;
  readAt: string | null;
  createdAt: string;
  sentBy: string | null;
}

export interface ConversationDetail {
  conversation: ConversationListItem;
  messages: InboxMessage[];
  customer: {
    id: string;
    firstName: string;
    lastName?: string | null;
    phone?: string | null;
  } | null;
  ticket: { id: string; ticketNumber: string } | null;
  openTickets?: Array<{ id: string; ticketNumber: string }>;
}

export const messagingApi = {
  listConversations(params?: {
    status?: string;
    channel?: string;
    search?: string;
    page?: number;
    pageSize?: number;
  }) {
    const qs = new URLSearchParams();
    if (params?.status) qs.set('status', params.status);
    if (params?.channel) qs.set('channel', params.channel);
    if (params?.search) qs.set('search', params.search);
    if (params?.page) qs.set('page', String(params.page));
    if (params?.pageSize) qs.set('pageSize', String(params.pageSize));
    const q = qs.toString();
    return apiGet<ConversationListItem[]>(`/api/v1/messaging/conversations${q ? `?${q}` : ''}`);
  },

  getConversation(id: string) {
    return apiGet<ConversationDetail>(`/api/v1/messaging/conversations/${id}`);
  },

  sendMessage(id: string, body: string) {
    return apiPost<{ status: string; messageId: string | null }>(
      `/api/v1/messaging/conversations/${id}/messages`,
      { body, channel: 'sms' },
    );
  },

  assign(id: string, userId: string | null) {
    return apiPost(`/api/v1/messaging/conversations/${id}/assign`, { userId });
  },

  resolve(id: string) {
    return apiPost(`/api/v1/messaging/conversations/${id}/resolve`);
  },

  linkTicket(id: string, ticketId: string) {
    return apiPost(`/api/v1/messaging/conversations/${id}/link-ticket`, { ticketId });
  },

  unreadCount() {
    return apiGet<{ unreadCount: number }>('/api/v1/messaging/unread-count');
  },
};
